var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewTaktplanning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "oi:link-broken",
    clipPath: "url(#clip0_3855_688)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 1H1V4.33333H6V1ZM0 0V5.33333H7V0H0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    id: "Union_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6666 6.33337H5.66663V9.66671H10.6666V6.33337ZM4.66663 5.33337V10.6667H11.6666V5.33337H4.66663Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    id: "Union_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 11.6666H10V15H15V11.6666ZM9 10.6666V16H16V10.6666H9Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3855_688"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewTaktplanning);
export default __webpack_public_path__ + "static/media/new_taktplanning.4b78907d57d9635ec60ec9503858b53f.svg";
export { ForwardRef as ReactComponent };